import React from "react";
import "./style.scss";


export const DefaultLoader = () => (
<div className="infinite-loader"></div>
);

